import { useAccountAvailableCashLinesApi } from '../api';

export const useAccountAvailableCash = () => {
  const response = useAccountAvailableCashLinesApi({});
  return response;
};
